import React from "react";
import { Route } from "react-router-dom";
import ProductTable from "./productTable";
import { Container } from "./styleCustom";

const Products = (props) => {
  return (
    <Container style={{ flexWrap: "wrap", flex: "1 1 100%" }}>
      <Route path={`${props.match.url}/list`} component={ProductTable} />
    </Container>
  );
};

export default Products;
